document.addEventListener('DOMContentLoaded', function () {


    const styleSheetRules = [
        `
            input:not([type="radio"]):not([type="checkbox"]), button[aria-expanded], textarea {
                border-radius: 0 !important;
                box-shadow: 0 0 0 1px #4A021A !important;
            }
        `,
        `
            div[class*="_formFileInput"] button[type="button"] {
                border: 1px dashed #4A021A !important;
                border-radius: 0 !important;
            }
        `,
        `
            form {
                margin-top: 1px !important;
            }
        `,
        `
            button[type="submit"] {
                background: #4A021A !important;
                color: #fff !important;
                border-radius: 0 !important;
                letter-spacing: var(--button-letter-spacing);
                font: var(--button-font);
                text-transform: uppercase !important;
            }
        `
    ];

    const allFormsObserver = new MutationObserver((mutationsList, observer) => {
        let formsCount = 0
        const formSections = document.querySelectorAll('.shopify-app-block[id*="forms_inline"]');

        if (formsCount === formSections.length) {
            observer.disconnect();
        }

        formSections.forEach(section => {
            const form = section.querySelector('form-embed');
            if (!form) return;
            const shadow = form.shadowRoot;
            if (!shadow) return console.warn('Shadow root non disponibile.');
            const sheet = new CSSStyleSheet();
            styleSheetRules.forEach(rule => {
                sheet.insertRule(rule);
            });
            shadow.adoptedStyleSheets.push(sheet);
            formsCount++;
        });

    });

    allFormsObserver.observe(document.body, { childList: true, subtree: true });

});
